import React from 'react';
import { Alert, Image } from 'react-bootstrap';
import hhieImage from '../assets/hhie-card.jpg';
import '../styles/Home.css';
import { HHIEButton } from './utility/HHIEButton';

export const Home = () => {
    return (
        <div 
            className="home-container" 
            style={{
                position: 'absolute', 
                left: '50%', 
                top: '50%',
                transform: 'translate(-50%, -60%)'
                ,maxWidth:'850px'
            }}
        >
            <div className="hhie-image-container">
                <Image src={hhieImage} fluid/>
            </div>
            <div className="login-button-container">
                <HHIEButton
                    id="enter-btn"
                    title="Enter Here" 
                    onClick={() => {window.location.href = "/login"}}
                    style={{
                        maxWidth: '850px'
                        ,borderRadius: '10px'
                        // ,minWidth: '228px'
                    }}
                />
            </div>
            <div className="sign-up-button-container">
               <Alert 
                className="contact-alert"
                variant="info">
                    <Alert.Heading>
                        <Alert.Link href="https://www.hawaiihie.org/help-desk">Need HHIE Services?</Alert.Link>
                    </Alert.Heading>
                    Contact the HHIE to register your organization.
                    <br/>
                    Email <strong>helpdesk@hawaiihie.org</strong> or call <strong>(808) 441-1374.</strong>
               </Alert>
            </div>
        </div>
    );
}
